// extracted by mini-css-extract-plugin
export default {"notfoundDiv":"Page404_notfoundDiv__8spsg","not":"Page404_not__PIzxd"};